import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import { useEffect } from "react";
import BlogPostsTable from "./components/BlogPostsTable.jsx";
import { useNavigate } from "react-router";
import { Box } from "@mui/material";
import { VisibilityOutlined } from "@mui/icons-material";
import DsButton from "@accredo/fe-shared/theme/components/Button.jsx";

export default function BlogIndexPage() {
  const { setBreadcrumbs } = useBreadcrumb();

  const navigate = useNavigate();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Einstellungen", path: "/admin/settings" },
      { name: "News-Verwaltung", path: "/admin/blog" },
    ]);
  }, [setBreadcrumbs]);

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <h1>News-Verwaltung</h1>
        <DsButton
          variant="tertiary"
          startIcon={<VisibilityOutlined />}
          onClick={() => navigate("/blog")}
        >
          Vorschau
        </DsButton>
      </Box>

      <BlogPostsTable
        onRowClick={(blogPost) => {
          if (!blogPost || !blogPost.id) {
            return;
          }
          navigate(`/admin/blog/${blogPost.id}`);
        }}
        onClickNew={() => navigate(`/admin/blog/neu`)}
      />
    </>
  );
}
